/**
 * Anonymous landing: steady black-on-white DomiOps wordmark with the O spinning
 * continuously (see Wordmark) and a
 * single "Log in" button pinned to the bottom, just above the app footer.
 * Negative top/bottom margins cancel the layout's banner padding + footer gap so
 * the white fills edge-to-edge.
 */
import { ArrowRight } from "lucide-react";
import { Wordmark } from "../components/BrandBadge";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="bg-white text-[#1d1d1f] -mt-4 -mb-12 min-h-[calc(100vh-3.5rem)] flex flex-col items-center px-6"
    >
      <div className="flex-1 w-full flex items-center justify-center">
        <h1 data-testid="landing-headline" className="text-6xl sm:text-7xl lg:text-8xl">
          <Wordmark testId="landing-wordmark" />
        </h1>
      </div>

      <button
        type="button"
        onClick={() => window.dispatchEvent(new Event("open-login"))}
        data-testid="landing-login-btn"
        className="mb-10 inline-flex items-center justify-center gap-2 rounded-full bg-[#0071e3] px-8 py-3 text-sm md:text-base font-normal text-white transition-colors duration-200 hover:bg-[#0060c0]"
      >
        Log in <ArrowRight size={18} strokeWidth={2.2} aria-hidden="true" />
      </button>
    </div>
  );
}
